module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.0c22b1d8.ttf";